import React from "react";
import Header from "../layout/Header";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Footer from "../layout/Footer";

export default function faqs() {
  return (
    <section>
      <Header />
      <div
        className="bg-homeSec1 bg-cover bg-center bg-no-repeat lg:py-72 sm:py-36 py-20 relative 
        before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black  
        before:bg-opacity-70"
      >
        <div className="md:w-4/5 sm:w-10/12 w-11/12 mx-auto flex flex-col items-center gap-y-7 relative text-center">
          <h1 className="font-bold lg:text-6xl sm:text-5xl text-4xl text-white">
            Shipping from China made easy!
          </h1>
          <p className="font-normal sm:text-base text-sm text-white text-opacity-80 xl:w-4/5">
            Pacifrica Express shipping services from China to anywhere in the
            world. Door-to-Door delivery by Air. At Pacifrica Express, we are
            committed to quality service to our customer. A state of the art
            tracking system is in place to track every consignment right from
            the collection point to the final destination.
          </p>
        </div>
      </div>
      <div className="pt-10 lg:pt-20 pb-10">
        <h2 className="text-2xl lg:text-4xl text-themeBlue font-semibold text-center">
          FAQ
        </h2>

        <div className="py-10 w-1/2 m-auto">
          <Accordion defaultIndex={[0]} allowMultiple borderColor="#124769">
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    1. What are Customs Duties and Taxes?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                All types of shipments (including gifts, samples and goods for
                repair) go through an import clearance process as determined by
                custom's regulations in the destination country. The shipment is
                cleared through customs based on the type of goods, origin
                country, the value and quantity. Dutiable shipments are subject
                to a customs duty, which is a tariff or tax imposed on goods
                when transported across international borders. <br /> <br /> The
                calculation of duties depends, in most countries, on the
                assessable value of a dutiable shipment. For the purpose of this
                calculation, dutiable goods are given a classification code that
                is known as the Harmonized System code, which determines the
                applicable duty rate. This system is a multipurpose
                international product nomenclature developed by the World
                Customs Organization and continues to evolve. <br /> <br /> The
                bases in determining the correct duties and taxes payable on
                imported goods is set out in the following Customs areas:
                <ul className="mt-4 space-y-2">
                  <li>Tariff</li>
                  <li>Valuation (value); and</li>
                  <li>Origin.</li>
                </ul>
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    2. Tariff
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                All import and export commercial transactions require
                commodities on Customs declarations to be classified according
                to an appropriate tariff heading. The tariff classification code
                is directly linked to the rate of duty payable on that
                commodity. Classification operates as part of the international
                Harmonised Commodity and Coding System, under the WCO Harmonised
                System Convention. <br />
                <br />
                Tariff classification of goods is one of the more complex issues
                under the Customs and Excise Act. Tariff classification relates
                to the proper classification of goods within the Harmonized
                Commodity Description and Coding System (tariff book). The
                Tariff Book indicates the normal customs duties (Schedule No 1,
                Part 1), excise duties (Schedule No 1, Part 2A), ad valorem
                duties (Schedule No 1, Part 2B), anti-dumping duties (Schedule
                No 2, Part 1) and countervailing duties (Schedule No 2, Part 2)
                that would be payable on importing goods into South Africa.
                Tariff classification of goods also determines the necessity for
                import control permits, the rules of origin obligations, and the
                applicability of any customs rebate provisions. <br />
                <br />
                The World Customs Organisation (WCO) issued the general rules of
                interpretation that are used as a guide in the correct
                classification of goods. It is crucial for an importer to have
                sufficient knowledge of these rules to ensure the correct
                classification of imported goods. It is important to ensure that
                an importer has a proper description of goods before the goods
                are imported into South Africa as the tariff code identified has
                to be inserted on the customs declaration. The customs duties
                and VAT payable will be calculated based on the rate of duty
                dictated by the specific tariff code. Failure to correctly
                classify goods within the tariff book could result in either
                under or over payment of Customs Duties and Value-Added Tax
                (VAT) on importation. <br /> <br />
                <strong>The structure of a tariff code</strong>
                <br />
                <br />
                Tariff codes are internationally identical up to the first 6
                digits. Thereafter each country my subdivide their codes
                depending on how specifically they want to regulate a type of
                import or export. Each country's tariff codes can be found in
                their tariff book. The South African tariff book is hosted and
                maintained by SARS Customs, but you can access it via our tariff
                code directory below. The first 2 digits of a tariff code refer
                to the chapter in the tariff book it falls under. The first 4
                digits are called the tariff heading and represent a broad
                category of products. A full South African tariff code is made
                of 8 digits and a 9th check digit. This code represents a
                specific product or commodity.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    3. What is Valuation?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                Customs values are set by the General Agreement on Tariffs and
                Trade (GATT) valuation code, which involves six valuation
                methods. The GATT Agreement on customs valuation has been
                accepted by all major trading countries. The Valuation Agreement
                prescribes six methods of valuation which must be applied in
                strict hierarchical order. Thus, if the transaction value cannot
                be ascertained in terms of Article 1, Article 2 must be tried,
                and so on. The methods, in order of precedence, are:
                <ul className="mt-4 space-y-2 list-decimal">
                  <li>
                    The transaction value of the goods, i.e. the price actually
                    paid or payable
                  </li>
                  <li>The transaction value of identical goods</li>
                  <li>The transaction value of similar goods</li>
                  <li>
                    The "deductive" method (where the customs value is derived
                    from the selling price of the imported goods in the
                    Republic)
                  </li>
                  <li>
                    The "computed" method (where the value is derived from the
                    built-up cost of the imported goods);
                  </li>
                  <li>
                    The so-called "fall back" method, being one of the other
                    five methods applied more flexibly.
                  </li>
                </ul>
                <br />
                However, the majority of goods are valued using method one,
                which is the actual price paid or payable by the buyer of the
                goods. The "free on board" price forms the basis for the value,
                but allows for certain deductions (such as interest charged on
                extended payment terms) and additions (such as certain
                royalties). Customs officials pay particular attention to:
                <ul className="mt-4 space-y-2 list-decimal">
                  <li>The relationship between the buyer and seller</li>
                  <li>
                    Payments outside of the normal transactions (such as
                    royalties and licence fees)
                  </li>
                  <li>Restrictions that have been placed on the buyer.</li>
                </ul>
                <br />
                These factors can result in the price being increased for the
                purpose of determining customs value, directly affecting the
                duty payable. For more information, refer to the Valuation of
                Imports and Method 1 Valuation of Imports policies.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    4. What are Rules of Origin?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                Rules of Origin are the criteria that are used to define where a
                product was made. They are an essential part of international
                trade rules because of policies that "discriminate" between
                exporting countries.
                <br />
                <br />
                The origin of a product is used to determine the import duty
                payable and whether it is subject to an antidumping or
                countervailing duty. It is also used for the compilation of
                trade statistics and for "Made in ..." Labels. <br />
                <br />
                In other words, the origin of a product is important because it
                will determine how it is treated at the border of an importing
                country and the origin may impact on the import duty payable and
                admissibility into the country.
                <br />
                <br />
                In addition, Rules of Origin may also determine whether goods
                are entitled to the payment of less or no Import duties. For
                this reason, there is a distinction between non-preferential and
                preferential Rules of Origin. <br /> <br />
                The non-preferential rules are applied for "Most-favoured
                Nation" (MFN) trade purposes (i.e. where goods are subject to
                the general rates of duty) and the preferential rules of origin
                are applied in the case of Free Trade Agreements and other
                preferential duty schemes (e.g. agreements where countries have
                agreed to eliminate or reduce import duties on goods produced in
                each other's territories).
                <br />
                <br />
                South Africa has signed a number of trade agreements with its
                trading partners in the past few years, including the TDCA,
                SADC, EFTA, SADC EPA and SACU MERCUSOR trade agreements. More
                information on these and other trade agreements can be found
                under Trade Agreements and Schedule 10. <br /> <br />
                Apart from trade agreements, South Africa also benefits from
                other international instruments or agreements, such as the
                African Growth and Opportunity Act (AGOA) and the different
                Generalized Systems of Preferences (GSPs), of which you will
                find more information under Other International Agreements.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    5. How is import VAT calculated
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                The VAT rate in South Africa is currently 15%. To calculate VAT
                on imported goods, the ATV (added tax value) needs to be
                determined first. This is done as follows: [(Customs Value + 10%
                thereof) + (any non-rebated duties levied on the goods)] x 15% =
                [ATV] x 15% = VAT payable
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    6. Billable Weight
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                When a parcel is transported, its actual weight (measured on a
                scale) and the amount of space it takes up (its volume) each
                play an important role in determining what it will cost to get
                it to its destination. The volume can also be expressed as the
                parcel's dimensional or volumetric weight. <br /> <br />
                The freight forwarder will consider the actual weight and the
                dimensional weight of your parcel and charge you for whichever
                is higher. The higher figure is therefore called the chargeable
                or billable weight. <br /> <br />
                To calculate billable weight, you will need the following
                information: <br />
                <ul className="mt-4 space-y-2">
                  <li>
                    Your parcel's dimensions in centimeters (cm) - this includes
                    length, breadth and width.
                  </li>
                  <li>Your parcel's weight in kilograms (kg).</li>
                  <li>
                    The conversion factor used by the freight company. We use a
                    factor of 5000.
                  </li>
                  <li>Length (cm) x Width (cm) x Height (cm)/5000</li>
                  <li>
                    Billable weight is therefore the greater of the two ( Actual
                    weight or Volumetric Weight)
                  </li>
                </ul>
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    7. Do I need an import license?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                You don't need an import license if we act as the importer on
                your behalf. If you only want us to take care of the shipping,
                you will need an import license which can be obtained by
                registering with SARS.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    8. Which shipping services do you use?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                We make use of various shipping services depending on the type
                of products and client's needs. It includes sea freight and air
                freight. We mostly use DHL, FedEx and UPS for air freight as we
                have preferential rates and longstanding relationships with
                these companies through our partners in China.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    9. Do you have a warehouse in China?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                We do have a warehouse in Shenzhen, China. If you purchase your
                products in China, you just ask your supplier to send your
                products to our warehouse and we will take care of the rest.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    10. I only have small items that I need to ship
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                It does not matter what the size of you parcel is. We ship any
                size and quantity at the best rates.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    11. I purchase my products on Alibaba. Can I use your
                    service?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                This is nothing new for sellers on Alibaba and they know that we
                offer better shipping prices than what they can offer.
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <h2>
                <AccordionButton
                  textColor="#124769"
                  _hover={{ bgColor: "#124769", textColor: "white" }}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontSize={30}
                    fontWeight={600}
                  >
                    12. How long do I have to wait for a shipment from China?
                  </Box>
                  <AccordionIcon fontSize={30} />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                fontSize={18}
                textColor="#124769"
                fontWeight={500}
              >
                Your shipment can be delivered as quickly as 10 days and it
                depends on which service provider and priority service being
                used.
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </div>
      </div>

      <Footer />
    </section>
  );
}
